import React from 'react'
import { useTranslation } from 'react-i18next'
import { useSnackbar } from 'notistack'

import { useRequestHandler } from '@/hooks/useRequestHandler'

import { useAppSelector } from '@/redux/rootReducer'
import { checkStripeAccount, selectAuthUser, selectAuthUserUpdateRequestState, updateMyProfile } from '@/redux/reducers/auth.reducer'
import {
  configureStripePayment,
  deleteStripeAccount,
  selectConfigureStripePaymentRequestTracker,
  selectDeleteStripePaymentRequestTracker,
} from '@/redux/reducers/staff.reducer'

import { isStaff } from '@/utils/type-guards'

import Payment from '../components/Payment'

export default function PaymentContainer() {
  const { enqueueSnackbar } = useSnackbar()
  const { t } = useTranslation()

  const authUser = useAppSelector(selectAuthUser)

  const updateAuthUserRequestHandler = useRequestHandler({
    onSuccess: () => {
      enqueueSnackbar(t('notification.authUser.update.success'), { variant: 'success' })
    },
    onError: () => enqueueSnackbar(t('notification.authUser.update.error'), { variant: 'error' }),
    requestTrackerSelector: selectAuthUserUpdateRequestState,
  })

  const configurePaymentRequestHandler = useRequestHandler({
    onSuccess: () => { },
    onError: () => {
      // TODO: @Thomas add error notification here
    },
    requestTrackerSelector: selectConfigureStripePaymentRequestTracker,
  })

  const deleteStripeAccountRequestHandler = useRequestHandler({
    onSuccess: () => {
      // TODO: @Thomas add success notification here
    },
    onError: () => {
      // TODO: @Thomas add error notification here
    },
    requestTrackerSelector: selectDeleteStripePaymentRequestTracker,
  })

  const handleConfigurePayment = () => {
    if (!authUser) return
    configurePaymentRequestHandler.dispatch(
      configureStripePayment({
        staffId: authUser._id,
        refreshUrl: `${window.location.origin}/configuration`,
        returnUrl: `${window.location.origin}/configuration`,
      })
    )
  }

  const handleDeleteStripeAccount = () => {
    if (authUser && authUser._id) deleteStripeAccountRequestHandler.dispatch(deleteStripeAccount({ staffId: authUser._id }))
  }

  const handleShowPaymentChange = () => {
    if (!authUser || !isStaff(authUser)) return

    updateAuthUserRequestHandler.dispatch(updateMyProfile({ showPayment: !authUser?.showPayment }))
  }

  const handleManualStripeUpdate = () => {
    if (!authUser) return
    configurePaymentRequestHandler.dispatch(
      checkStripeAccount({
        staffId: authUser._id,
      })
    )
  }

  if (!authUser || !isStaff(authUser)) return null

  return (
    <Payment
      isActivated={authUser.stripeActivated}
      isConfiguring={configurePaymentRequestHandler.requestTracker.loading}
      isDeleting={deleteStripeAccountRequestHandler.requestTracker.loading}
      isUpdatingShowPayment={updateAuthUserRequestHandler.requestTracker.loading}
      onConfigurePayment={handleConfigurePayment}
      onDeletePaymentAccount={handleDeleteStripeAccount}
      onShowPaymentChange={handleShowPaymentChange}
      showPayment={authUser.showPayment}
      checkStripe={handleManualStripeUpdate}
    />
  )
}
